// @ts-nocheck
import {Percent, CurrencyUSD, Time, GraphQLDecimal} from '@/graphql/scalars'

import * as Types from '../../../../types/schema';

import { GiftingProposalProjectionFragment } from '../../../../modules/gifting/proposal/graphql/GiftingProposalProjection.fragment.generated';
import { gql } from '@apollo/client';
import { GiftingProposalProjectionFragmentDoc } from '../../../../modules/gifting/proposal/graphql/GiftingProposalProjection.fragment.generated';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type UpdateGiftProposalMutationVariables = Types.Exact<{
  input: Types.AugmentedUpdateProposalInput;
}>;


export type UpdateGiftProposalMutation = { __typename?: 'Mutation', updateProposalV2: { __typename?: 'Proposal', id: string, giftingProposal?: { __typename?: 'GiftingProposal', id: string, giftingScenarios?: Array<{ __typename?: 'GiftingProposalScenario', id: string, projections: (
          { __typename?: 'GiftingProposalProjections' }
          & GiftingProposalProjectionFragment
        ) }> | null } | null } };

export const Operations = {
  Mutation: {
    UpdateGiftProposal: 'UpdateGiftProposal' as const
  }
}

/**
 * Custom plugin to wrap useQuery hooks with automatic context.fetchPolicy injection
 */
function withFetchPolicyContext(options) {
  const fetchPolicy = options?.fetchPolicy ?? 'cache-first';
  const isLazy = options?.isLazy ?? undefined;
  return {
    ...options,
    context: {
      ...options?.context,
      fetchPolicy,
      isLazy,
    },
  };
}

/**
 * Defaults useSubscription to ignoreResults: true so Apollo skips its
 * per-message useSyncExternalStore notification (forceStoreRerender). All
 * call sites manage state via onData; opting out avoids render storms when
 * messages arrive in a synchronous burst. See T2-10011. Callers that need
 * Apollo to surface data/loading/error can override by passing
 * ignoreResults: false explicitly.
 */
function withSubscriptionIgnoreResults(options) {
  return {
    ignoreResults: true,
    ...options,
  };
}


export const UpdateGiftProposalDocument = gql`
    mutation UpdateGiftProposal($input: AugmentedUpdateProposalInput!) {
  updateProposalV2(input: $input) {
    id
    giftingProposal {
      id
      giftingScenarios {
        id
        projections {
          ...GiftingProposalProjection
        }
      }
    }
  }
}
    ${GiftingProposalProjectionFragmentDoc}`;
export type UpdateGiftProposalMutationFn = Apollo.MutationFunction<UpdateGiftProposalMutation, UpdateGiftProposalMutationVariables>;

/**
 * __useUpdateGiftProposalMutation__
 *
 * To run a mutation, you first call `useUpdateGiftProposalMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateGiftProposalMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateGiftProposalMutation, { data, loading, error }] = useUpdateGiftProposalMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateGiftProposalMutation(baseOptions?: Apollo.MutationHookOptions<UpdateGiftProposalMutation, UpdateGiftProposalMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateGiftProposalMutation, UpdateGiftProposalMutationVariables>(UpdateGiftProposalDocument, options);
      }
export type UpdateGiftProposalMutationHookResult = ReturnType<typeof useUpdateGiftProposalMutation>;
export type UpdateGiftProposalMutationResult = Apollo.MutationResult<UpdateGiftProposalMutation>;
export type UpdateGiftProposalMutationOptions = Apollo.BaseMutationOptions<UpdateGiftProposalMutation, UpdateGiftProposalMutationVariables>;